import React, { FunctionComponent } from "react";
import { MenuItemContent } from "./MenuItemContent";
import { cn } from "../../utils/cn";

export interface MenuItemDividerProps {
  className?: string;
}

/**
 *
 */
export const MenuItemDivider: FunctionComponent<MenuItemDividerProps> = ({
  className,
}) => {
  const css = cn(className);
  return (
    <MenuItemContent className={css}>
      <hr className="h-[1px] border-0 bg-gray-300" />
    </MenuItemContent>
  );
};
